import { createStore, applyMiddleware } from "redux";
import reducer from "./reducer/index";
import thunk from "redux-thunk";
import logger from "redux-logger";
import promise from "redux-promise-middleware";

const middleware = applyMiddleware(promise(), thunk, logger());

export default createStore(reducer, middleware);
